import script from "./department-select.vue?vue&type=script&setup=true&lang=js"
export * from "./department-select.vue?vue&type=script&setup=true&lang=js"

import "./department-select.vue?vue&type=style&index=0&id=1bee5c56&lang=scss&scoped=true"
import "./department-select.vue?vue&type=style&index=1&id=1bee5c56&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bee5c56"]])

export default __exports__